<template>
    <div class="well-card-details" :class="{ 'fda-friendly': isFdaFriendly }" @click.stop="">
        <template v-if="!isFdaFriendly">
            <well-rank class="card" :well="well" />

            <pn-score v-if="isTooEarlyForScores" :well="well" />
            <kid-score
                v-else
                option="well-card-option"
                :well="well"
                :only-background-high-score="true"
            />

            <blast-score :well="well" option="well-card-option" />

            <well-last-event :well="well" mode="card" />

            <fert-method-dropdown
                v-if="tenant.settings.showCycleDetails && isWellCardView"
                :well="well"
                default-label="ins_method"
                class="fertilization-status"
            />
        </template>

        <well-status-controls :well="well" :keep-open="isFdaFriendly" mode="cards" />
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import WellRank from '../common/WellRank'
import PnScore from '../score-metrics/PnScore'
import KidScore from '../score-metrics/KidScore'
import BlastScore from '../score-metrics/BlastScore'
import WellLastEvent from '../common/WellLastEvent'
import WellStatusControls from '../common/WellStatusControls'
import FertMethodDropdown from '../common/FertMethodDropdown'
import { TREATMENT_PAGE_VIEWS } from '../../../business/const'

export default {
    name: 'WellCardDetails',
    components: {
        FertMethodDropdown,
        PnScore,
        WellRank,
        KidScore,
        BlastScore,
        WellLastEvent,
        WellStatusControls
    },
    props: {
        well: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapState({
            currentView: state => state.navigation.currentView
        }),
        ...mapGetters({
            isFdaFriendly: 'common/isFdaFriendly',
            isTooEarlyForScores: 'timelapse/isTooEarlyForScores',
            tenant: 'common/getTenant'
        }),
        isWellCardView() {
            return this.currentView === TREATMENT_PAGE_VIEWS.WELL_CARDS
        }
    }
}
</script>

<style lang="scss" scoped>
.well-card-details {
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 8px;

    &:not(.fda-friendly) {
        grid-template-rows: repeat(3, 1fr) min-content;
    }
    &.fda-friendly {
        grid-template-rows: min-content;
    }
    .fertilization-status {
        @media screen and #{$new-break4close} {
            display: none;
        }
    }
}
</style>

<style lang="scss">
.well-card-details {
    min-width: 85px;

    .well-rank.card {
        .title {
            font-size: 10.5px;
        }
        .value {
            font-size: 14px;

            .ai-icon {
                height: 14px;
            }
        }

        &.top-rank .crown {
            width: 1.5rem;
        }
    }

    .fert-method-dropdown,
    .well-status-controls {
        height: 1.5rem;
    }
}
</style>
